import { Component } from '@angular/core';

@Component({
  selector: 'modal-sin-oponente',
  templateUrl: 'modal-sin-oponente.html'
})
export class ModalSinOponenteComponent {

  show: boolean = false;

  constructor() {
  }

  close() {
    this.show = !this.show;
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-sin-oponente/modal-sin-oponente.ts